import React from 'react';

const Fulfillment = () => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 22 22"
    width="17"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M21 8l-4-4H3a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h1a2 2 0 1 0 4 0h6a2 2 0 1 0 4 0h1a1 1 0 0 0 1-1V9a1 1 0 0 0-.293-.707zM6 19a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm12 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2zM4 6h12.586l3 3H4V6z"></path>
  </svg>
);

export default Fulfillment;
